function ninjaGame(canvasJQ,game_conf,conf){
    conf=$.extend({
        onLoad:function(){},
        onLose:function(){},
        onWin:function(){}
    },conf);
    this.conf=conf;
    $.addToPlacePreloader(function(){
        conf.onLoad();
        //complite
    },[],{addToLoader:1,waitMili:0});

    this.game_conf=game_conf;
    this.conf=conf;
    var val_need=intval(game_conf.state.val_need);
    if(intval(game_conf.val_need)>0){
        val_need=intval(game_conf.val_need)
    }

    this.state={lives_max:3,val:intval(game_conf.repeat.val),val_need:val_need,
        boss:{val:0,val_need:5}
    };
    this.state.lives=this.state.lives_max;
    this.stage={name:"start","val":-1,howlong_need:0,res:""};




    this.game_obj;
};
ninjaGame.prototype={
    gameHandler:function(){
        //abstract
    },
    startView:function(){
        //abstract
    },
    startBoss:function(){
        //abstract
    },
    nextStage:function(conf){
        //abstract
    },
    test:function(){
        //abstract
    },

    start:function(){
        this.game_obj.start();
        this.startView();
        if(this.conf.isTest){
            this.test();
        }
        else{
            this.during();
        }

    },
    initStage:function(){
        var val=this.state.val;
        this.stage.howlong_need=150;

        if(val>=this.state.val_need){
           this.startBoss();
           this.stage.name="boss";
           return false;
        }

        var val_sum=0;
        var i,bum,start_key=-1;
        for(i in this.game_conf.stages.start){
            bum=this.game_conf.stages.start[i];
            val_sum+=bum.egg_max;
            if(val<val_sum){
                start_key=i;
                break;
            }
        }
        if(start_key!=-1){
            this.stage.name="start";
            this.stage.val=intval(start_key)-1;
            return true;
        }
        this.stage.name="next";
        return true;
    },
    nextConf:function(){
        this.stage.val++;
        if(this.stage.name=="start"){
            if(typeof this.game_conf.stages.start[this.stage.val]!="undefined"){
                return this.game_conf.stages.start[this.stage.val];
            }
            else{
                this.stage.name="next";
            }
        }
        else if(this.stage.name=="next" && this.state.val>=this.state.val_need){
            if(typeof this.game_conf.stages.boss!="undefined"){
                this.stage.name="boss";
                //wait on boss
                this.startBoss();
            }
            else{
                //win if end

                if(this.stage.res==""){
                    this.stage.res="win";
                    this.conf.onWin({val:this.state.val,boss:0});
                }


                return {howlong:0};
            }

        }
        return this.game_conf.stages[this.stage.name];


    },
    takeStageRow:function(){
        this.game_conf.stages[this.stage.name]
    },

    during:function(){
        this.gameHandler();


        var thc=this;
        var gameObj=this.game_obj;
        var time_last=gameObj.takeHowlong();
        var howlong_have=0;
        this.initStage();

        _moduleTimeHandler.add(function(){
            if(thc.stage.res!=""){
                return false;
            }
            var time_cur=gameObj.takeHowlong();
            var howlong=time_cur-time_last;
            time_last=time_cur;

            howlong_have+=howlong;
            if(howlong_have>=thc.stage.howlong_need){
                howlong_have-=thc.stage.howlong_need;
                var newConf=thc.nextConf();
                if(newConf && newConf.howlong>0){
                    thc.stage.howlong_need=newConf.howlong-howlong_have;
                    thc.nextStage(newConf);
                }
            }


        },100);


//        this.state={lives_max:1,val:intval(game_conf.repeat.val),val_need:val_need,boss_killed:0};
//    this.state.lives=this.state.lives_max;


    },
    takeState:function(){
        return copyObj(this.state);
    }
};
